import React from "react";

const Loader = ({type}) => {
  return (
    <div className="loader-div d-flex flex-column gap-2">
      <div className="loaderr"></div>
      {/* {type && <h3 className="text-white fs-18">Loading assets.....</h3>} */}
    </div>
  );
};

export default Loader;

/* <div className={{loader-overlay">
<div className={{spinner" />
</div> */
